import { render, staticRenderFns } from "./BoardTemplate.vue?vue&type=template&id=4b95e61a&scoped=true"
import script from "./BoardTemplate.vue?vue&type=script&lang=js"
export * from "./BoardTemplate.vue?vue&type=script&lang=js"
import style0 from "./BoardTemplate.vue?vue&type=style&index=0&id=4b95e61a&prod&lang=scss"
import style1 from "./BoardTemplate.vue?vue&type=style&index=1&id=4b95e61a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b95e61a",
  null
  
)

export default component.exports